module.exports = __webpack_public_path__ + "static/img/product1-1.92f8e5ca.png";